<template>
  <div class="project">
    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img id="navbar-logo" src="../../assets/projects/wf/wf.png" alt="Logo">
      </div>
    </nav>

    <h1>Work Experience @WeFact - Projects</h1>

    <h2>What is WeFact?</h2>
    <p> WeFact is the biggest invoicing app in the Netherlands targeting small, medium and big companies to help simplifying the chore of invoicing. With WeFact you can create invoices and quotes, process purchase invoices and have up-to-date insight into your administration. </p>

    <h2>What did I do for WeFact?</h2>
    <p>At WeFact my main task was to design and develop new features for our main SaaS application named "Mijn WeFact", and also work on the API connected React app which is usable on Apple and Google app stores. Usually tickets come in in our Jira and these tasks need to be picked up and reviewed by my colleagues. Tasks could also be part of a Epic but usually it took some communicating with the rest of the backend team to discuss the best way to implement any new main feature.</p>
    <br>
    <p>Some other projects I worked on were the old and the new corporate website's, together with one other colleague we built a better maintainable website by introducing a cms (Prepr) to make changing pages easy and completely custom. Our frontend was setup with ReactJS, Apollo and NextJS. We created all kind of components which could be added on a page template, this way you could create and link to as many pages as you need all with specific WeFact based components and blocks. </p>

  </div>
</template>

<style>
@import 'project.css';
</style>
